<template>
  <div>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col lg="6" md="12" sm="12">
              <b-form-group id="group-first_name" label-for="admin-first_name" label="الاسم الأول">
                <b-input-group>
                  <b-form-input id="baroun-first_name" name="baroun-first_name" v-model="$v.form.first_name.$model"
                    :state="validateState('first_name')" placeholder="الاسم الأول"></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-edit-first_name" :force-show="$v.form.first_name.$error">
                  {{ "الاسم الاول مطلوب" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="12" sm="12">
              <b-form-group id="group-last_name" label-for="admin-last_name" label="اسم العائلة">
                <b-input-group>
                  <b-form-input id="baroun-last_name" name="baroun-last_name" v-model="$v.form.last_name.$model"
                    :state="validateState('last_name')" placeholder="اسم العائلة"></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-edit-last_name" :force-show="$v.form.last_name.$error">
                  {{ "اسم العائلة مطلوب" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group label="النوع">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-icon icon="person"></b-icon>
                  </b-input-group-prepend>
                  <b-form-select v-model="form.gender" :options="['ذكر', 'أنثى']"></b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group id="group-phone" label-for="admin-phone" label="رقم الهاتف">
                <phone-input id="baroun-phone" placeholder="1012345678" v-model="$v.form.phone.$model"
                  :state="validateState('phone')"></phone-input>
                <b-form-invalid-feedback id="input-edit-phone" :force-show="$v.form.phone.$error">
                  {{ " رقم الهاتف مطلوب" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group id="group-parent_phone" label-for="admin-parent_phone" label="رقم هاتف ولي الامر">
                <phone-input id="baroun-parent_phone" placeholder="1012345678" v-model="$v.form.parent_phone.$model"
                  :state="validateState('parent_phone')"></phone-input>
                <b-form-invalid-feedback id="input-edit-parent_phone" :force-show="$v.form.parent_phone.$error">
                  {{ $v.form.parent_phone.required ? "رقم هاتف ولي الامر يجب أن يختلف عن رقم الطالب" : "رقم هاتف ولي الامر مطلوب" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group id="group-email" label-for="admin-email" label="البريد الاكتروني">
                <b-form-input type="email" id="baroun-email" name="baroun-email" v-model="$v.form.email.$model"
                  :state="validateState('email')"></b-form-input>
                <b-form-invalid-feedback id="input-edit-email" v-if="!$v.form.email.required">
                  {{ " البريد الاكتروني مطلوب" }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="input-edit-email" v-if="!$v.form.email.email">
                  {{ " البريد الاكتروني غير صالح" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group id="group-password" label-for="admin-password" label="كلمة المرور">
                <b-form-input type="password" id="baroun-password" name="baroun-password"
                  v-model="$v.form.password.$model" :state="validateState('password')"></b-form-input>
                <b-form-invalid-feedback id="input-edit-password" v-if="!$v.form.password.required">
                  {{ " كلمة المرور مطلوبة" }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="input-edit-password" v-if="!$v.form.password.minLength">
                  {{ " كلمة المرور يجب ان تكون على الاقل 6 حروف" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <b-form-group id="group-password_confirmation" label-for="admin-password_confirmation"
                label="اكد كلمة المرور">
                <b-form-input type="password" id="baroun-password_confirmation" name="baroun-password_confirmation"
                  v-model="$v.form.password_confirmation.$model"
                  :state="validateState('password_confirmation')"></b-form-input>
                <b-form-invalid-feedback id="input-edit-password_confirmation"
                  v-if="!$v.form.password_confirmation.required">
                  {{ " كلمة المرور مطلوبة" }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback id="input-edit-password_confirmation"
                  v-if="!$v.form.password_confirmation.sameAsPassword">
                  {{ " كلمة المرور غير مماثله" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="sendSuccess" class=" mb-2 p-2 bg-success text-white rounded">
            تم انشاء الحساب بنجاح - سيتم تحويلك لتسجيل الدخول
          </div>
          <template v-if="errorMessages">
            <div class=" mb-2 p-2 bg-dark text-white rounded" v-for="errorMessage in errorMessages" :key="errorMessage">
              {{ errorMessage }}
            </div>
          </template>

          <b-button aria-label="انشاء حساب" :disabled="isLoading" type="submit" variant="brand" block>
            <span class="text-center text-white my-2" :class="{ 'alert-div-padding': isLoading }" v-show="isLoading">
              جاري انشاء الحساب <b-spinner class="align-middle mx-2"></b-spinner>
            </span>
            <span v-show="!isLoading">
              انشاء الحساب
            </span>
          </b-button>
        </b-form>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <img style="width: 100%; height: 250px; object-fit: contain;" src="../../assets/images/login_img.png"
          alt="انشاء حساب - منصة البارون">
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { sendRequest } from "../../utils/RequestHelper.js"
import jwt_decode from "jwt-decode";
import store from "../../store/index.js"
import PhoneInput from "./PhoneInput.vue"

import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  sameAsPassword
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  components: { PhoneInput },
  props: ['goToLogin'],

  data() {

    return {
      alertCountdown: 0,
      alertType: '',
      alertText: '',
      form: {
        first_name: '',
        last_name: '',
        gender: 'ذكر',
        phone: '',
        parent_phone: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      isLoading: false,

      fieldLabels: {
        first_name: 'الاسم الأول',
        last_name: 'اسم العائلة',
        gender: 'النوع',
        phone: 'رقم الهاتف',
        parent_phone: 'رقم هاتف ولي الامر',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        password_confirmation: 'تأكيد كلمة المرور',
      },
      apiMessages: {
        'user with this phone already exists.': 'رقم الهاتف موجود بالفعل',
        'user with this email already exists.': 'البريد الالكتروني موجود بالفعل',
        'Enter a valid phone number: 10 to 15 digits, optionally prefixed with +.':
          'رقم الهاتف غير صالح. أدخل من 10 إلى 15 رقمًا',
        'Enter a valid name: letters, spaces, hyphens and apostrophes only.':
          'الاسم غير صالح. من فضلك استخدم حروفًا فقط',
        'Ensure this field has no more than 100 characters.':
          'هذا الحقل يجب ألا يزيد عن 100 حرف',
        'This field is required.': 'هذا الحقل مطلوب',
        'Passwords do not match': 'كلمتا المرور غير متطابقتين',
        'Parent phone must differ from the student phone.':
          'رقم هاتف ولي الامر يجب أن يختلف عن رقم الطالب',
      },
      selfDescribing: [
        'رقم الهاتف موجود بالفعل',
        'البريد الالكتروني موجود بالفعل',
        'كلمتا المرور غير متطابقتين',
      ],

      sendError: false,
      sendSuccess: false,
      errorMessages: [],
    };
  },

  // validations
  validations: {
    form: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      phone: {
        required
      },
      parent_phone: {
        required,
        differsFromPhone: function (value) {
          return !value || value !== this.form.phone
        }
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      password_confirmation: {
        required,
        sameAsPassword: function (value) {
          return value === this.form.password
        }
      },
    },
  },
  methods: {
    countDownChanged(alertCountdown) {
      this.alertCountdown = alertCountdown
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.register();
    },
    registerErrorMessages(apiError) {
      if (apiError.code === 'network_error') {
        return ['تعذر الاتصال بالخادم. تأكد من اتصالك بالإنترنت وحاول مرة أخرى'];
      }
      const errors = apiError.errors;
      if (!errors || typeof errors !== 'object') {
        return ['تعذر إنشاء الحساب. من فضلك حاول مرة أخرى'];
      }
      const messages = [];
      Object.keys(errors).forEach((field) => {
        const raw = errors[field];
        const items = Array.isArray(raw) ? raw : [raw];
        items.forEach((item) => {
          const text = String(item);
          const known = this.apiMessages[text];
          // Some messages already name their field ("phone already exists");
          // the generic ones need the label or the user cannot tell which of
          // two rejected fields the message belongs to.
          if (known && this.selfDescribing.indexOf(known) !== -1) {
            messages.push(known);
            return;
          }
          const label = this.fieldLabels[field];
          const body = known || text;
          messages.push(label ? label + ': ' + body : body);
        });
      });
      return messages.length
        ? messages
        : ['تعذر إنشاء الحساب. من فضلك حاول مرة أخرى'];
    },
    resetForm() {
      this.form = {
        first_name: '',
        last_name: '',
        gender: 'ذكر',
        phone: '',
        parent_phone: '',
        email: '',
        password: '',
        password_confirmation: '',
      };
      this.$v.form.$reset();
    },
    register() {
      this.isLoading = true;
      this.errorMessages = []
      this.sendError = false;
      let data = Object.assign({}, this.form)
      data.gender = this.form.gender == 'ذكر' ? 'male' : 'female'
      var successCallback = () => {
        this.sendSuccess = true;
        this.isLoading = false;
        this.resetForm();

        setTimeout(() => {
          // call function in parent
          this.$emit('goToLogin');
        }, 2000);
      };

      var errorCallback = (apiError) => {
        this.errorMessages = this.registerErrorMessages(apiError);
        this.sendError = true;
        this.isLoading = false;
      };
      sendRequest('post', 'auth/register/', false, data, successCallback, errorCallback, true);
    }
  }
};
</script>

<style scoped>
.register-container {
  background: #f8f9fa;
}

.register-card {
  width: 70%;
  border-radius: 10px;
}

.is-invalid {
  border: 2px solid red !important;
}
</style>
